import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ErrorComponent } from "./error.component";
import { ErrorRoutingModule } from "./error-routing.module";
import { SharedModule } from "../../../../app/shared";

@NgModule({
  imports: [CommonModule, ErrorRoutingModule, SharedModule],
  declarations: [ErrorComponent],
})
export class ErrorModule {}
